import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import {
  PostAcceptedPools,
  PostAutoTuneV2Config,
  PostDeleteAcceptedPools,
  PostSiteOrgConfig,
} from "../../api/api";

type AutoTuneV2ConfigResult = {
  status: string;
  notification?: boolean;
  msg?: string;
};

type AutoTuneV2Config = {
  config_name: string;
  config_type: string;
};

export const usePostDeletePriceConfig = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      config_name,
      config_type,

      token,
    }: AutoTuneV2Config & {
      token: string;
    }): Promise<AutoTuneV2ConfigResult> =>
      PostAutoTuneV2Config(
        token,
        {
          config_name,
          config_type,
        },
        "DELETE"
      ),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { config_name, config_type }: AutoTuneV2Config,
      options?: {
        onSuccess?: (data: AutoTuneV2ConfigResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        {
          config_name,
          config_type,

          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
